import {
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "../../../ui/dropdown-menu";
import { HeaderItemType, TitleHeaderContentType } from "../types";

const TitleHeaderContent = ({ header }: { header: TitleHeaderContentType }) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-purple-muted-300">{header.title}</span>
      <span>{header.label}</span>
    </div>
  );
};

export const HeaderItem = ({
  header,
}: {
  header: HeaderItemType | undefined;
}) => {
  if (!header) {
    return null;
  }
  return (
    <>
      <DropdownMenuLabel className="text-purple-100 font-normal px-3">
        {header.type === "MenuTitleHeader" && (
          <TitleHeaderContent header={header} />
        )}
      </DropdownMenuLabel>
      <DropdownMenuSeparator className="bg-purple-muted-500" />
    </>
  );
};
